import axios from 'smg/axios';
import { GetCountry, GetState } from 'smg/countries';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as session from 'smg/customer-api/session';
import { Session } from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { UUID } from 'smg/uuid';
import { PageLoader } from '../account';
import * as address from '../address';
import { Relref } from '../hugo';
import { CheckPOBoxAddress, PromptNew } from '../shippingoptions';

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const sess = await Session();

    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const parent = document.querySelector('#shippingAdressesContainer') as HTMLElement;
    const addNewButton = document.querySelectorAll('.addNew');
    const cardTemplate = document.querySelector('#cards') as HTMLTemplateElement;

    addNewButton.forEach(el => {
        el.addEventListener('click', async () => {
            await PromptNew(sess).then(() => {
                pl.Load();
            });
        });
    });

    const pl: PageLoader<models.ShippingOption> = new PageLoader<models.ShippingOption>({
        afterLoad: () => {
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        parent: document.querySelector('#shippingAdressesContainer') as HTMLElement,
        get: () => axios.get<hyejoo.ShippingOptions>('/shipping-options', {
            params: {
                'sort': pl.Sort(),
                'max': pl.CurrentPageSize(),
                // 'data': 'fullName, company, email, addressLine1, addressLine2, zip, phone, stateID, countryID, city',
                'p': pl.CurrentPage(),
                'q': pl.Search(),
            },
        }).then(resp => ({ rows: resp.data.shippingOptions, nextPage: resp.data.nextPage })),
        draw: async shippingOption => {
            //  shippionOption.country/state are not a part of the response from the api! If so, it cause a lot a much larger response from the database,
            //  reducing speed. In order for the Draw function to perform properly, it needs those two keys. So, you must hard code them.
            const c: models.Country = {
                countryCode2: await GetCountry(shippingOption.countryID as models.CountryID).then(resp => resp?.countryCode2),
            };

            const s: models.State = {
                stateCode: await GetState(shippingOption.countryID as models.CountryID, shippingOption.stateID as number).then(resp => resp?.stateCode),
            };

            shippingOption.country = c;
            shippingOption.state = s;

            const card = template.Clone(cardTemplate);
            const addressEl = await address.Draw(shippingOption, shippingOption.phone, shippingOption.email);
            const addressParent = card.querySelector<HTMLElement>('.address');

            addressParent?.appendChild(addressEl);

            // Grab user details
            const session = await Session();
            const editBtn = card.querySelector('.edit-btn') as HTMLButtonElement;
            const deleteBtn = card.querySelector('.delete-btn') as HTMLButtonElement;

            editBtn?.addEventListener('click', () => {
                void PromptNew(session).then(newOption => {
                    shippingOption = newOption;
                    pl.Load();
                });
            });

            deleteBtn?.addEventListener('click', () => {
                void shippingoptions.DeleteShippingOption(shippingOption.id || '').then(() => {
                    card.parentElement?.removeChild(card);
                    const undoLinkID = `undo-${UUID()}`;
                    const t = toast.Success(`Removed shipping option. <a href="#" class="text-white text-decoration-underline" id="${undoLinkID}">Undo</a>`);
                    const undo = document.querySelector(`#${undoLinkID}`) as HTMLAnchorElement;
                    undo.addEventListener('click', async e => {
                        e.preventDefault();
                        t?.dispose();
                        await shippingoptions.RestoreShippingOption(shippingOption.id || '');
                        pl.Load();
                    });
                    pl.Load();
                });
            });
            void CheckPOBoxAddress(shippingOption.countryID as models.CountryID, shippingOption.stateID || 0, shippingOption.addressLine1 || '', addressParent as HTMLElement);
            return card;
        },

    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.Load();
}